export default __webpack_public_path__ + "static/media/logo.b5d8a4d3.png";